const realtyMge = r => require.ensure([], () => r(require('@/page/realtyMge/realtyMge')), 'realtyMge');
const propertyContractRecord = r => require.ensure([], () => r(require('@/page/realtyMge/propertyContractRecord/propertyContractRecord')), 'propertyContractRecord');
const propertyContractRecordAccept = r => require.ensure([], () => r(require('@/page/realtyMge/propertyContractRecord/propertyContractRecordAccept')), 'propertyContractRecordAccept');
const propertyContractRecordCensor = r => require.ensure([], () => r(require('@/page/realtyMge/propertyContractRecord/propertyContractRecordCensor')), 'propertyContractRecordCensor');
const propertyContractExamination = r => require.ensure([], () => r(require('@/page/realtyMge/propertyContractRecord/propertyContractExamination')), 'propertyContractExamination');
const propertyAreaRecord = r => require.ensure([], () => r(require('@/page/propertyMge/propertyArea/propertyAreaRecord')), 'propertyAreaRecord');
const propertyAreaRecordCensor = r => require.ensure([], () => r(require('@/page/propertyMge/propertyArea/propertyAreaRecordCensor')), 'propertyAreaRecordCensor');
const propertyAreaRecordExamine = r => require.ensure([], () => r(require('@/page/propertyMge/propertyArea/propertyAreaRecordExamine')), 'propertyAreaRecordExamine');
const propertyAreaRecordAccept = r => require.ensure([], () => r(require('@/page/propertyMge/propertyArea/propertyAreaRecordAccept')), 'propertyAreaRecordAccept');
const StarRatingManagement = r => require.ensure([], () => r(require('@/page/propertyMge/starRatingManagement/StarRatingManagement')), 'StarRatingManagement');
const DeclarationOfStarRating = r => require.ensure([], () => r(require('@/page/propertyMge/declarationOfStarRating/DeclarationOfStarRating')), 'DeclarationOfStarRating');
const sunshineBill = r => require.ensure([], () => r(require('@/page/propertyMge/sunshineBill/sunshineBill')), 'sunshineBill');
const annualBudget = r => require.ensure([], () => r(require('@/page/propertyMge/annualBudget/annualBudget')), 'annualBudget');
const budgetStatus = r => require.ensure([], () => r(require('@/page/propertyMge/budgetStatus/budgetStatus')), 'budgetStatus');
const reformReconstruction = r => require.ensure([], () => r(require('@/page/propertyMge/reformReconstruction/reformReconstruction')), 'reformReconstruction');
const carInfo = r => require.ensure([], () => r(require('@/page/propertyMge/carInfo/carInfo')), 'carInfo');
const feesStandard = r => require.ensure([], () => r(require('@/page/propertyMge/feesStandard/feesStandard')), 'feesStandard');
const serviceContract = r => require.ensure([], () => r(require('@/page/propertyMge/serviceContract/serviceContract')), 'serviceContract');
const serviceContractDetail = r => require.ensure([], () => r(require('@/page/propertyMge/serviceContract/serviceContractDetail/serviceContractDetail')), 'serviceContractDetail');
const serviceStaffInfoMge = r => require.ensure([], () => r(require('@/page/propertyMge/serviceStaffInfoMge/serviceStaffInfoMge')), 'serviceStaffInfoMge');
const addEaServiceContract = r => require.ensure([], () => r(require('@/page/propertyMge/addEaServiceContract/addEaServiceContract')), 'addEaServiceContract');
const starEvaluteAccept = r => require.ensure([], () => r(require('@/page/propertyMge/starEvaluteAccept/starEvaluteAccept')),'starEvaluteAccept');
const starEvaluteCensor = r => require.ensure([], () => r(require('@/page/propertyMge/starEvaluteCensor/starEvaluteCensor')),'starEvaluteCensor');
const newsRecord = r => require.ensure([], () => r(require('@/page/newsMge/newsRecord')), 'newsRecord');
const noticeDetail = r => require.ensure([], () => r(require('@/page/newsMge/noticeDetail')), 'noticeDetail');
const updateBidNotice = r => require.ensure([], () => r(require('@/page/newsMge/updateBidNotice')), 'updateBidNotice');
const addNewsRecord = r => require.ensure([], () => r(require('@/page/newsMge/addNewsRecord')), 'addNewsRecord');

const realtyMgeRouter = {
  path: '',
  component: realtyMge,
  meta: {
    icon: 'organMge', 
    right: [],
    isShowMenu: true,
    keepAlive:true
  },
  name: '物业管理',
  children: [
    {
      path: '/propertyContractRecord',
      component: propertyContractRecord,
      name: '物业服务合同备案',
      meta: {
        right: [],
        isShowMenu: true,
        workTemplateName: '物业服务合同备案',
        keepAlive:true
      },
    },
    {
      path: '/propertyasdafa',
      name: '物业服务合同备案',
      meta: {
        right: [],
        isShowMenu: true,
        workflow: true,
        workTemplateName: '物业服务合同备案',
        keepAlive:true
      },
    },  
    {
      path: '/propertyContractRecordAccept',
      component: propertyContractRecordAccept,
      name: '物业服务合同备案受理',
      meta: {
        right: [],
        isShowMenu: true,
        keepAlive:true
      },
    }, 
    {
      path: '/propertyContractExamination',
      component: propertyContractExamination,
      name: '物业服务合同备案审查',
      meta: {
        right: [],
        isShowMenu: true,
        keepAlive:true
      },
    }, 
    {
      path: '/propertyContractRecordCensor',
      component: propertyContractRecordCensor,
      name: '物业服务合同备案审核',
      meta: {
        right: [],
        isShowMenu: true,
        keepAlive:true
      },
    }, 
    {
      path: '/propertyAreaRecord',
      component: propertyAreaRecord,
      name: '物业区域备案',
      meta: {
        right: [],
        isShowMenu: false,
        keepAlive:true
      },
    }, 
    // {
    //   path: '/propertyAreaRecordWork',
    //   name: '物业区域备案',
    //   meta: {
    //     right: [],
    //     isShowMenu: true,
    //     workflow: true,
    //     workTemplateName: '物业区域备案'
    //   },
    // },  
    {
      path: '/propertyAreaRecordAccept',
      component: propertyAreaRecordAccept,
      name: '物业区域受理',
      meta: {
        right: [],
        isShowMenu: true,
        keepAlive:true
      },
    },
    {
      path: '/propertyAreaRecordCensor',
      component: propertyAreaRecordCensor,
      name: '物业区域备案审核',
      meta: {
        right: [],
        isShowMenu: true,
        keepAlive:true
      },
    }, 
    {
      path: '/propertyAreaRecordExamine',
      component: propertyAreaRecordExamine,
      name: '物业区域备案审查',
      meta: {
        right: [],
        isShowMenu: true,
        keepAlive:true
      },
    },
    {
      path: '/StarRatingManagement',
      component: StarRatingManagement,
      name: '星级评定管理',
      meta: {
        right: [],
        isShowMenu: true,
        keepAlive:true
      },
    }, 
    {
      path: '/sunshineBill',
      component: sunshineBill,
      name: '阳光晒账',
      meta: {
        right: [],
        isShowMenu: true,
        keepAlive:true
      },
    },
    {
      path: '/StarEvaluteBisAdd',
      component: DeclarationOfStarRating,
      name: '星级评定申报',
      meta: {
        right: ['星级评定申报'],
        isShowMenu: false,
        keepAlive:true
        
      },
    },
    {
      path: '/DeclarationOfStarRating',
      component: DeclarationOfStarRating,
      name: '星级评定申报',
      meta: {
        right: [],
        isShowMenu: true,
        workTemplateName: '星级评定',
        workflow: true,
        keepAlive:true
      },
    },
    {
      path:'/StarEvaluteAccept',
      component:starEvaluteAccept,
      name:'星级评定受理',
      meta: {
        right: [''],
        isShowMenu: false,
        keepAlive:true
      },
    },
    {
      path:'/StarEvaluteCensor',
      component:starEvaluteCensor,
      name:'星级评定审核',
      meta: {
        right: [''],
        isShowMenu: false,
        keepAlive:true
      },
    },
    {
      path: '/annualBudget',
      component: annualBudget,
      name: '年度预算',
      meta: {
        right: [],
        isShowMenu: true,
        keepAlive:true
      },
    }, 
    {
      path: '/budgetStatus',
      component: budgetStatus,
      name: '收支情况',
      meta: {
        right: [],
        isShowMenu: true,
        keepAlive:true
      },
    }, 
    {
      path: '/reformReconstruction',
      component: reformReconstruction,
      name: '改造改建',
      meta: {
        right: [],
        isShowMenu: true,
        keepAlive:true
      },
    },  
    {
      path: '/carInfo',
      component: carInfo,
      name: '车位信息',
      meta: {
        right: [],
        isShowMenu: true,
        keepAlive:true
      },
    }, 
    {
      path: '/feesStandard',
      component: feesStandard,
      name: '收费标准',
      meta: {
        right: [],
        isShowMenu: true,
        keepAlive:true
      },
    }, 
    {
      path: '/serviceContract',
      component: serviceContract,
      name: '服务合同',
      meta: {
        right: [],
        isShowMenu: true,
        keepAlive:true
      },
    }, 
    {
      path: '/serviceContractDetail',
      component: serviceContractDetail,
      name: '服务合同详情',
      meta: {
        right: [],
        isShowMenu: false,
        keepAlive:true
      },
    },
    {
      path: '/serviceStaffInfoMge',
      component: serviceStaffInfoMge,
      name: '管理服务人员信息',
      meta: {
        right: [],
        isShowMenu: true,
        keepAlive:true
      },
    },
    {
      path: '/addEaServiceContract',
      component: addEaServiceContract,
      name: '添加物业服务合同',
      meta: {
        right: [],
        isShowMenu: true,
        keepAlive:true
      },
    },
    {
      path: '/newsRecord',
      component: newsRecord,
      name: '招投标公告',
      meta: {
        right: [],
        isShowMenu: true,
        keepAlive:true
      },
    },
    {
      path: '/noticeDetail',
      component: noticeDetail,
      name: '招投标公告详情',
      meta: {
        right: [],
        isShowMenu: false,
        keepAlive:true
      },
    },
    {
      path: '/updateBidNotice',
      component: updateBidNotice,
      name: '招投标公告编辑',
      meta: {
        right: [],
        isShowMenu: false,
        keepAlive:true
      },
    },    
    {
      path: '/addNewsRecord',
      component: addNewsRecord,
      name: '招投标公告新增',
      meta: {
        right: [],
        isShowMenu: false,
        keepAlive:true
      },
    },
  ]
}; 

export default realtyMgeRouter;